import { PageLoading } from '@components/page-loading';
import React, { LazyExoticComponent, Suspense } from 'react';

export const withSuspense = <T extends React.ComponentType<any>, K extends LazyExoticComponent<T>>(
  WrappedComponent: K
) => props => (
  <Suspense fallback={<PageLoading />}>
    <WrappedComponent {...props} />
  </Suspense>
);

export * from './react';
export * from './create-control-field';
export * from './create-control-field-services';
export * from './create-control-field-services_c2c';
export * from './create-control-field-projects';
export * from './create-control-field-projects_c2c';

